/* eslint-disable arrow-body-style */
// eslint-disable-next-line import/prefer-default-export
export const formatNumber = (locale: string, number?: number | null): string => {
  if (number === null || number === undefined) return '';
  return new Intl.NumberFormat(
    locale,
    { maximumFractionDigits: 20, useGrouping: false },
  ).format(number);
};
